module.exports = __webpack_public_path__ + "img/icon_tlyw_70.b6ca405d.png";